import { FormatedTutorsResponse, TutorsResponse } from '../types';
import { Button } from '@octano/global-ui';
import { PermissionName } from '../../../../../types/Auth';
import useUserState from '../../../../../hooks/useUserState';
import { useTexts } from './useTexts';
import { format } from 'rut.js';

export function useColumns(
  data: TutorsResponse['studentPlansAndTutors']['studyPlans'],
  setModalOpen: Function,
  setModalData: Function,
): FormatedTutorsResponse {
  const { isAuthorizedTo } = useUserState();
  const texts = useTexts();

  return {
    studyPlans: data.map((plan) => {
      return {
        name: <p>{plan.name}</p>,
        studyPlanEnrollmentId: plan.studyPlanEnrollmentId,
        tutor: plan.tutor ? (
          <>
            <p>{plan.tutor.names}</p>
            <p>{format(plan.tutor.identification, { dots: true })}</p>
          </>
        ) : (
          <b>{texts.notAssigned}</b>
        ),
        tutorEmail: plan.tutor ? (
          <p>{plan.tutor.email}</p>
        ) : (
          <b>{texts.notAssigned}</b>
        ),
        action: (
          <Button
            type="button"
            style={{ width: '50%' }}
            text={texts.table.editTutorButton}
            size="sm"
            onClick={() => {
              setModalOpen(true);
              setModalData(plan);
            }}
            disabled={!isAuthorizedTo([PermissionName.TEACHER_MANAGEMENT_ALL])}
          />
        ),
      };
    }),
  };
}
